import { Share2 } from "lucide-react";

/**
 * ShareWhatsAppButton — pre-fills a WhatsApp share with the item details + link.
 *
 * Props:
 *  - title: string (required)
 *  - subtitle: string (e.g. "5 days · ₹18,500" / "Karnataka")
 *  - path: string (e.g. "/tours/bhairav-ghad")
 *  - variant: "floating" | "inline" (default "floating")
 */
export default function ShareWhatsAppButton({ title, subtitle, path, variant = "floating", className = "", testId }) {
  const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const url = `${window.location.origin}${path}`;
    const parts = [`Check out this trip on On Wheels — *${title}*`];
    if (subtitle) parts.push(subtitle);
    parts.push(url);
    const msg = parts.join("\n");
    const wa = `https://wa.me/?text=${encodeURIComponent(msg)}`;
    window.open(wa, "_blank", "noopener,noreferrer");
  };

  const base = "inline-flex items-center justify-center transition-all";
  const styles = variant === "floating"
    ? "w-9 h-9 rounded-full bg-white/95 backdrop-blur border border-[#E5DDCB] shadow hover:scale-110"
    : "gap-2 px-4 h-10 rounded-full border border-[#25D366]/40 bg-[#25D366]/10 hover:bg-[#25D366]/20 text-sm font-medium text-[#1F4D3A]";

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={`Share ${title} on WhatsApp`}
      data-testid={testId || "share-whatsapp-btn"}
      className={`${base} ${styles} ${className}`}
    >
      <Share2 className={`w-4 h-4 ${variant === "inline" ? "text-[#128C7E]" : "text-[#4A3728]"}`} strokeWidth={2} />
      {variant === "inline" && <span>Share on WhatsApp</span>}
    </button>
  );
}
